import loadable from '@loadable/component';
import { ClientOnly } from 'remix-utils/client-only';
import type { TProps } from '../ApiRunner';
import SpinBlock from '../SpinBlock';

const ApiRunner = loadable(() => import('../ApiRunner'), {
  fallback: <SpinBlock />,
});

type ApiRunnerProps = TProps;
export default function AsyncApiRunner(props: ApiRunnerProps) {
  return <ClientOnly fallback={<SpinBlock />}>{() => <ApiRunner {...props} />}</ClientOnly>;
}
